import React, { useEffect, useState } from 'react'
import compose from 'recompose/compose'
import { withI18n } from '../../hocs'
import ActionDialog from '../action-dialog'
import { patchRpaIntegration } from '../../../api'
import { useMutation } from "@tanstack/react-query";
import { ALERT_LEVEL, INTEGRATIONS_RPA } from '../../../config/constants';
import { useAppContext } from '../../../context/appContext';

const ModalDisableIntegration = ({ open, handleClose, i18n, integrationData, onDataUpdate, self_data }) => {
  const { createAlert } = useAppContext();
  const [toggleCurrentStatus, setToggleCurrentStatus] = useState(null);
  const [integrationDataState, setIntegrationDataState] = useState(null);

  useEffect(() => {
    if (open) {
      const newCurrentStatus = integrationData ? integrationData.active : false;
      setToggleCurrentStatus(newCurrentStatus);
      setIntegrationDataState(integrationData);
    }

  }, [open, integrationData]);

  const options = [
    { id: INTEGRATIONS_RPA.INFOJOBS_PROVIDER, name: i18n.keywords_rpa.sourceInfojobs },
    { id: INTEGRATIONS_RPA.EPRESELEC_PROVIDER, name: i18n.keywords_rpa.sourceEpreselec },
    { id: INTEGRATIONS_RPA.COMPUTRABAJO_PROVIDER, name: i18n.keywords_rpa.sourceComputrabajo },
    { id: INTEGRATIONS_RPA.PANDAPE_PROVIDER, name: i18n.keywords_rpa.sourcePandape },
  ];

  const providerName = options.find(option => integrationData && option.id === integrationData.provider)?.name;

  const changeStatusIntegration = async (data) => {
    const response = await patchRpaIntegration(data.id, self_data.client_id, data);
    return response.data;
  }

  const mutationChangeStatusIntegration = useMutation(changeStatusIntegration);

  // El modal se cierra cuando ha ido bien y la tabla ya está refrescada; el aviso de éxito lo da la página
  const handleClickDisable = async (e) => {
    e.preventDefault();
    try {
      if (integrationDataState && integrationDataState.id) {
        await mutationChangeStatusIntegration.mutateAsync({
          id: integrationDataState.id,
          active: !integrationDataState.active,
        });
        await onDataUpdate();
        handleClose();
      }
    } catch (error) {
      console.error('Error in Disable or Enable Integration:', error);
      createAlert(integrationDataState?.active ? i18n.keywords_rpa.errorDisableIntegration : i18n.keywords_rpa.errorEnableIntegration, ALERT_LEVEL.ERROR);
    }
  };

  const handleModalClose = () => {
    setToggleCurrentStatus(null);
    setIntegrationDataState(null);
    handleClose();
  };

  const getTitleForConfirmation = () => {
    if (integrationDataState && toggleCurrentStatus) {
      return i18n.keywords_rpa.confirmDisabledIntegration
        .replace('{position}', `${integrationDataState.candidature.name || ''}`)
        .replace('{provider}', `${providerName || ''}`);
    } else if (integrationDataState) {
      return i18n.keywords_rpa.confirmEnabledIntegration
        .replace('{position}', `${integrationDataState.candidature.name || ''}`)
        .replace('{provider}', `${providerName || ''}`);
    }
    return '';
  };

  return (
    <ActionDialog
      open={open}
      title={getTitleForConfirmation()}
      onClose={handleModalClose}
      onConfirm={handleClickDisable}
      cancelLabel={i18n.dialog.decline}
      confirmLabel={integrationDataState && integrationDataState.id
        ? !toggleCurrentStatus
          ? i18n.keywords_rpa.buttonConfirmEnabledIntegration
          : i18n.keywords_rpa.buttonConfirmDisabledIntegration
        : null}
      confirmColor={toggleCurrentStatus ? 'error' : 'default'}
      isPending={mutationChangeStatusIntegration.isLoading}
    />
  )
}

const enharce = compose(withI18n)

export default enharce(ModalDisableIntegration)